var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorPermissions = function SvgErrorPermissions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#error-permissions_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.05 101.15c-3.58-6.34-7.164-12.673-10.75-19-.3 3.947-.604 7.904-.91 11.87L6.3 90.4c.96 3.534 1.923 7.067 2.89 10.6h3.26l10.6.15Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.242 33.615c3.955-3.887 4.117-10.135.362-13.956-3.754-3.821-10.005-3.768-13.96.119-3.954 3.886-4.116 10.134-.362 13.955 3.755 3.821 10.005 3.768 13.96-.118ZM102.59 101.169H91.03l2.43-69.61h11.56l-2.43 69.61Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.63 101.169H16.07l2.43-69.61h11.56l-2.43 69.61Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.79 94.97.34-9.84h77.52l-.34 9.84H20.79ZM106.207 33.614c3.955-3.886 4.118-10.134.363-13.955-3.755-3.821-10.005-3.768-13.96.118-3.955 3.887-4.117 10.135-.362 13.956 3.754 3.821 10.005 3.768 13.959-.119ZM108.9 48.86l-.12 3.29v.01L108 74.53H11.91l.9-25.67h96.09Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.43 48.86 69.71 74.53H57.35l15.72-25.67h12.36ZM108.9 48.86l-.12 3.29v.01l-13.7 22.37H82.71l15.72-25.67h10.47ZM60.07 48.86 44.35 74.53H31.98L47.7 48.86h12.37ZM34.7 48.86 18.98 74.53h-7.07l.32-9.17 10.1-16.5H34.7Z",
    fill: "#116DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 93.17a11.001 11.001 0 0 0-10.16 7.7H114a7.746 7.746 0 0 0-8-7.7ZM59.11 88.62l-5.54 5.31a3967.362 3967.362 0 0 1-3.25-14.86L46.8 93.69l-4.5-5.54-.93 12.76h3.7v.22h10.07v-.15h2.84c.36-4.146.737-8.266 1.13-12.36Z",
    fill: "#28BF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1 37.08a9.94 9.94 0 0 1-6-2l.59-.8a9 9 0 0 0 5.41 1.77 9.63 9.63 0 0 0 5.56-1.78l.57.82a10.57 10.57 0 0 1-6.13 1.99ZM99.06 37.08a10 10 0 0 1-6-2l.59-.81a9 9 0 0 0 5.41 1.77 9.628 9.628 0 0 0 5.56-1.78l.57.82a10.569 10.569 0 0 1-6.13 2ZM90.582 85.126l-.347 9.834 1 .035.346-9.834-1-.035ZM104.43 47.84H92.88v1h11.55v-1ZM103.5 74.52H91.95v1h11.55v-1ZM29.47 47.84H17.92v1h11.55v-1ZM28.53 74.52H16.98v1h11.55v-1ZM28.213 85.127l-.346 9.834.999.035.347-9.834-1-.035ZM100.48 100.87c-4.35-6.62-11-4.85-13.18-.09l13.18.09Z",
    fill: "#192C55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.72 100.67H2.27v1h115.45v-1Z",
    fill: "#192C55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "error-permissions_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgErrorPermissions;